<template>
  <div class="list">
    <notifications></notifications>
    <navbar :docsName="docsName"/>
    <div class="container-fluid">
      <div class="row">
        <div class="col-2">
          <div class="container-fluid">
            <head-menu-filter
              :col="12"
              class="d-xl-flex"
              :headline="$t('global.filter')"
            ></head-menu-filter>

            <div class="row mb-2">
              <div
                class="viewfilter block br-t-l-0 br-t-r-0 w-100-p br-t-l-xl-0 br-t-r-xl-0 mt-minus-10"
              >
                <div class="row">
                  <div class="col-xl-12">
                    <single-select-person
                      id="verantwortlicher"
                      :person="filters.verantwortlicher"
                      :label="$t('global.Responsible')"
                      :allowOpen="false"
                      editable
                      @confirmed="setVerantwortlicher"
                    />
                  </div>
                </div>

                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group" id="number-of-records">
                      <input
                        v-model="filters.count"
                        class="form-control input"
                        type="text"
                        placeholder=" "
                      />
                      <label>{{ $t("global.numberofrecords") }}</label>
                    </div>
                  </div>
                </div>
                <filter-search-reset-button />
              </div>
            </div>
          </div>
        </div>
        <div class="col-10">
          <div class="container-fluid">
            <head-menu
              :col="12"
              class="d-xl-flex"
              :headline="$t('global.campaigns')"
              :anzahl="kampagnenliste.length"
              :anzahlAusFilter="anzahlDatenFilter"
            ></head-menu>
            <div class="row mb-2">
              <div class="block br-t-l-0 w-100-p br-t-l-xl-0">
                <div class="row mt-2 d-flex justify-content-between">
                  <div class="ml-4 mr-2">
                    <button
                      class="btn btn-success mr-2"
                      @click="neueKampagne"
                      v-if="berechtigungen.m_kampagne.create"
                    >
                      <font-awesome-icon icon="fa-regular fa-plus" />
                      {{ $t("global.new") }}
                    </button>
                  </div>
                  <div class="mr-4">
                    <button
                      class="btn btn-danger"
                      @click="oeffneLoeschenModal"
                      v-if="berechtigungen.m_kampagne.delete"
                      :disabled="isDisabled"
                    >
                      <font-awesome-icon
                        icon="fa-duotone fa-trash"
                        class="mr-2"
                      />
                      <span>{{ $t("global.delete") }}</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="row block belegliste">
              <div class="w-100-p">
                <div>
                  <b-table
                    ref="selectableTable"
                    small
                    tbody-tr-class="item"
                    :items="listData"
                    :fields="fields"
                    :sort-compare="sortDates"
                    sort-icon-left
                    fixed
                    selectable
                    select-mode="range"
                    @row-dblclicked="details"
                    thead-tr-class="pointer"
                  >
                    <template slot="top-row" slot-scope="{ fields }">
                      <td class="no-pointer" v-for="field in fields" :key="field.key">
                        <b-input
                          v-if="
                            field.key != 'selected' && field.searchable != false
                          "
                          size="sm"
                          v-model="filters[field.key]"
                          :placeholder="field.label"
                        />
                      </td>
                    </template>

                    <template v-slot:head(selected)="header">
                      <b-form-checkbox
                        ref="headerCheckbox"
                        v-model="header.selected"
                        @input="selectAllRows(header)"
                      ></b-form-checkbox>
                    </template>

                    <template v-slot:cell(selected)="row">
                      <b-form-checkbox
                        v-model="row.item.selected"
                        @input="onRowSelected(row)"
                      ></b-form-checkbox>
                    </template>
                  </b-table>

                  <infinite-loading
                    :identifier="infiniteId"
                    @infinite="infiniteHandler"
                  >
                    <div slot="spinner">{{ $t("global.loadmoredata") }}</div>
                    <div slot="no-more">{{ $t("global.nofurtherdata") }}</div>
                    <div slot="no-results">
                      {{ $t("global.nofurtherdatafound") }}
                    </div>
                  </infinite-loading>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <loeschen-modal
      id="kampagnen-loeschen-modal"
      @confirmed="loeschen"
      :multiple="true"
    />

    <loading-overlay v-show="loading"></loading-overlay>
  </div>
</template>

<script>
import Api from "@/Api";
import HeadMenu from "@/components/HeadMenu";
import HeadMenuFilter from "@/components/HeadMenuFilter";
import Navbar from "@/components/Navbar";
import LoeschenModal from "@/components/Modals/LoeschenModal";
import store from "@/store";
import page from "@/mixins/Page";
import dashboard from "@/mixins/Dashboard";
import filter from "@/mixins/Filter";
import SingleSelectPerson from "@/components/global/SingleSelectPerson.vue";
import FilterSearchResetButton from "@/components/Buttons/FilterSearchResetButton";

import { LADE_AUSWAHLWERTE_CRM } from "@/store/crm/actions.type";

export default {
  name: "Kampagnen",
  components: {
    Navbar,
    HeadMenu,
    HeadMenuFilter,
    LoeschenModal,
    SingleSelectPerson,
    FilterSearchResetButton,
  },
  metaInfo() {
    return {
      titleTemplate: () => {
        return "BX: " + this.$t("global.campaigns");
      },
    };
  },
  mixins: [page, dashboard, filter],
  props: {
    id: {
      type: String,
      required: false,
      default: null,
    },
  },
  store,
  data() {
    return {
      kampagnenliste: [],
      isDisabled: true,
      selected: [],
      selectedIds: [],
      filterMitarbeitende: this.$CONST("ROLLEN").MITARBEITER,
    };
  },
  computed: {
    fields() {
      return [
        { key: "selected", label: "" },
        {
          key: "bezeichnung",
          sortable: true,
          label: this.$t("global.designation"),
          searchable: false,
        },

        {
          key: "status.bezeichnung",
          sortable: true,
          label: this.$t("global.status"),
          searchable: false,
        },
        {
          key: "erstelltdatum",
          sortable: true,
          label: this.$t("global.created"),
          tdClass: "text-center",
          thClass: "text-center",
          searchable: false,
        },
        {
          key: "gestartetdatum",
          sortable: true,
          label: this.$t("global.launched"),
          tdClass: "text-center",
          thClass: "text-center",
          searchable: false,
        },
        {
          key: "enddatum",
          sortable: true,
          label: this.$t("global.finished"),
          tdClass: "text-center",
          thClass: "text-center",
          searchable: false,
        },
        {
          key: "verantwortlicher.personName",
          sortable: true,
          label: this.$t("global.Responsible"),
          searchable: false,
        },
      ];
    },
    queryParams: function () {
      var params = {};

      params.ver = this.setQueryParam(this.filters.verantwortlicher?.id);
      params.filterCount = this.setQueryParam(this.filters.count);

      return params;
    },
    kampagnestati: {
      get() {
        return this.$store.state.crm.kampagnestati;
      },
    },
  },
  created() {
    this.initFilter("kampagnen-liste", "crm/kampagne/", true);
  },
  mounted() {
    this.$bus.$emit("searchWithFilter");
    if (this.kampagnestati.length == 0)
      this.$store.dispatch(`crm/${LADE_AUSWAHLWERTE_CRM}`);
  },
  methods: {
    details(kampagne) {
      this.$router.push({
        name: "kampagne",
        params: { id: kampagne.id, anzeige: 0 },
      });
    },

    neueKampagne() {
      this.$router.push({
        name: "kampagne",
        params: { anzeige: 0 },
      });
    },

    loeschen() {
      Api.delete("crm/kampagne/", { data: this.selectedIds }).then(
        (response) => {
          this.schliesseLoeschenModal();

          this.listData = this.listData.filter(
            (v) => !response.data.success.includes(v.id)
          );
        }
      );
    },

    schliesseLoeschenModal() {
      $("#kampagne-loeschen-modal").modal("hide");
    },

    oeffneLoeschenModal() {
      $("#kampagne-loeschen-modal").modal("show");
    },

    setVerantwortlicher(person) {
      this.$set(this.filters, "verantwortlicher", person);
    },
  },
};
</script>

<style></style>
